<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
    <template slot="menuLeft">
        <el-button
          
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="addRecord"
        >
          新 增</el-button
        >
      </template>
    </avue-crud>
      </div>
      <hr-dialog title="新增保养记录" :allowFull="false" width="60%" :visible.sync="maintenanceVisible">
      <template slot="body">
        <maintenanceRecordForm
        
          :row="row"
          @cancle="recordCancle"
          v-if="maintenanceVisible"
          @success="recordSuccess"
         
        ></maintenanceRecordForm>
      </template>
    </hr-dialog>
    </div>
  </template>
    <script>

  import maintenanceRecordForm from './maintenanceRecordForm.vue';
  import { getSmartDeviceResumeUpkeeplist } from '@/api/nursingHome/artificalDevice';
  export default {
    components: {maintenanceRecordForm},
    props: {
      row: {
        default: {},
      },
      nursinghomeId: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        maintenanceVisible:false,
        formRow:{},
       data:[],
       option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: '500',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '保养日期',
            prop: 'upkeepTime',
          },
          {
            label: '保养人员',
            prop: 'upkeepUserName',
          },
          {
            label: '保养费用',
            prop: 'upkeepAmount',
          },
          {
            label: '保养说明',
            prop: 'description',
          },
          
         
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      };
    },
    created() {
      this.initData();
    },
    mounted() {
      this.$refs.crud.doLayout();
    window.onresize = () => {
      this.$refs.crud.doLayout();
    };
    },
    activated() {
      this.$refs.crud.doLayout();
    },
    watch: {},
    methods: {
      refleshTable(){
        setTimeout(() => {
        this.$nextTick(() => {
        this.$refs.crud.doLayout();
      })
      },100)
      },
      addRecord(){
        this.maintenanceVisible =true
      },
      recordCancle(){
        this.maintenanceVisible =false
      },
      recordSuccess(){
        this.maintenanceVisible =false
        this.onLoad()
      },
      onLoad(){
        getSmartDeviceResumeUpkeeplist({id: this.row.id}).then((res) => {
          this.data = res.data
          this.$nextTick(() => {
            this.$refs.crud.doLayout();
          })
        })
      }
    
    },
  };
  </script>
    <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
    